module.exports = __webpack_public_path__ + "img/139.34d6c594.jpg";